export default {"src":"/_next/static/media/toMarkdown.341025b9.svg","height":322,"width":763,"blurWidth":0,"blurHeight":0};